import { createTheme } from 'uiKit/atoms/styles/styles';
import '../../assets/styles/variables.scss';
import '../../assets/styles/mixins.scss';

const theme = createTheme({
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          border: 'none',
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          padding: '0px 56px',
          maxWidth: '1280px',
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          marginTop: '0px !important',
          marginBottom: '0px !important',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        list: {
          paddingTop: '0px',
          paddingBottom: '0px',
          border: '1px solid #E0E0E0',
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        toolbar: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '32px 0 64px 0',
        },
        selectLabel: {
          display: 'none',
        },
        select: {
          fontFamily: 'Futura PT Medium',
          position: 'relative',
          padding: '12px 84px 12px 105px !important',
          border: '1px solid #d0dadb',
          borderRadius: '25px',
          '::before': {
            content: '"Rows Per Page:"',
            position: 'absolute',
            left: '15px',
            top: '50%',
            transform: 'translateY(-50%)',
            paddingRight: '10px',
          },
          focused: {
            borderRadius: '25px',
          },
          MuiInputBase: {
            input: {
              ':focus': {
                borderRadius: '25px !important',
              },
            },
          },
        },

        displayedRows: {
          fontFamily: 'Futura PT Medium',
          position: 'relative',
          margin: '0 10px 0px auto',
        },
        selectIcon: {
          right: '20px',
        },

        spacer: {
          display: 'none',
        },
        menuItem: {
          borderRadius: '25px',
          fontFamily: 'Futura PT Medium',
          alignContent: 'right',
          '::before': {
            content: '"Rows Per Page:"',
            fontSize: '14px',
          },
        },
      },
    },
  },
});

export default theme;
